"use strict";

module.exports = {
  'name': 'cosh',
  'category': 'Trigonometry',
  'syntax': ['cosh(x)'],
  'description': 'Compute the hyperbolic cosine of x in radians.',
  'examples': ['cosh(0.5)'],
  'seealso': ['sinh', 'tanh', 'coth']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/cosh.js
// module id = 967
// module chunks = 0